// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__51xuY","filesListContainer":"PosDisputesFiles_filesListContainer__IVfXz","filesButton":"PosDisputesFiles_filesButton__1c2ps"};